// test2230
(2230 && 0);
